import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/dusuk-goz-kapaginda-botoks-kullanimi/page.tsx");
